/* eslint-disable react/jsx-fragments */
import React, { useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Modal, Select } from 'sa-ui/';
import Field from 'app/common/Field';
import omit from 'lodash/omit';
import { Row, Col, Alert } from 'react-bootstrap';
import * as actions from './editClassActions';
import messages from './editStudentModalMessages';
import EditStudentModalType from './editStudentModalType';

// refatorar depois, idealmente seria melhor o back retornar código único de erro
function getErrorMessage(serverMessage) {
  switch (true) {
    case /exists/gi.test(serverMessage) && /school/gi.test(serverMessage):
      return messages.error_schoolNotFound;
    case /exists/gi.test(serverMessage) && /course/gi.test(serverMessage):
      return messages.error_courseNotFound;
    case /permission/gi.test(serverMessage) && /add/gi.test(serverMessage):
      return messages.error_addPermissionDenied;
    case /permission/gi.test(serverMessage) && /edit/gi.test(serverMessage):
      return messages.error_editPermissionDenied;
    case /registration code is already in use by another student/gi.test(serverMessage):
      return messages.error_registrationAlreadyExists;
    case /student is already registered with this registration/gi.test(serverMessage):
      return messages.error_studentAlreadyRegisteredWithThisRegistration;
    case /student is already registered in this course with this email/gi.test(serverMessage):
      return messages.error_studentAlreadyRegisteredInThisCourseWithThisEmail;
    case /exists/gi.test(serverMessage) && /student/gi.test(serverMessage):
      return messages.error_studentAlreadyExists;
    case /Sorry, there is already another user with the email you entered/gi.test(serverMessage):
      return messages.error_emailAlreadyExists;
    default:
      return messages.error_generic;
  }
}

const EditStudentModalForm = (props) => {
  useEffect(() => {
    if (!props.show) {
      props.resetForm({});
    }
  }, [props.show]);

  useEffect(() => {
    if (Object.keys(props.values).length > 0 && Object.keys(props.touched).length === 0) {
      props.validateForm(props.values);
    }
  }, [props.values]);

  function getTitleMessage() {
    switch (props.type) {
      case EditStudentModalType.ADD:
        return messages.addTitle;
      case EditStudentModalType.EDIT:
        return messages.editTitle;
      case EditStudentModalType.VIEW:
        return messages.viewTitle;
      default:
        return messages.addTitle;
    }
  }

  function handleContinue() {
    if (props.type === EditStudentModalType.EDIT) {
      props.onEdit(props.values);
    } else {
      props.onAdd(props.values);
    }
  }

  function errors() {
    if (props.error) {
      const errorMessage = getErrorMessage(props.error);
      return (
        <Alert variant="danger">
          <FormattedMessage {...errorMessage} />
        </Alert>
      );
    }
    return null;
  }
  const isValid = Object.keys(props.values).length > 0 && Object.keys(props.errors).length === 0;

  const closeButton = {
    onClick: props.onClose,
    label: <FormattedMessage {...messages.back} />,
  };
  const continueButton = {
    onClick: handleContinue,
    disabled: !isValid,
    primary: true,
    label: <FormattedMessage {...messages.continue} />,
  };
  const buttons = props.readOnly ? [closeButton] : [closeButton, continueButton];
  return (
    <Modal
      show={props.show}
      onClose={props.onClose}
      icon="pe-7s-user"
      message={props.readOnly ? '' : props.intl.formatMessage(messages.message)}
      title={<FormattedMessage {...getTitleMessage()} />}
      buttons={buttons}
    >
      <Fragment>
        {/* <pre>{JSON.stringify(props.values, null, 2)}</pre>
        <pre>{JSON.stringify(props.errors, null, 2)}</pre>
        <pre>valido {isValid ? 'SIM' : 'NÃO'}</pre>   */}
        {errors()}
        <Row className="mt-3">
          <Col xs={12}>
            <Field
              name="firstname"
              readOnly={props.readOnly}
              placeholder={props.intl.formatMessage(messages.name)}
            />
          </Col>
          {/* <Col xs={12}>
            <Field
              name="lastname"
              readOnly={props.readOnly}
              placeholder={props.intl.formatMessage(messages.lastname)}
            />
          </Col> */}
          <Col xs={12}>
            <Field
              name="registration"
              readOnly={props.readOnly}
              placeholder={props.intl.formatMessage(messages.registration)}
            />
          </Col>
          <Col xs={12}>
            <Field
              name="call"
              placeholder={props.intl.formatMessage(messages.call)}
              readOnly={props.readOnly}
            />
          </Col>
          <Col xs={12}>
            <Field
              name="email"
              placeholder={props.intl.formatMessage(messages.email)}
              readOnly={props.readOnly}
            />
          </Col>
          <Col xs={12} style={{ textAlign: 'left' }}>
            <Field
              component={Select}
              name="newIdEsCourse"
              label={props.intl.formatMessage(messages.course)}
              readOnly={props.readOnly}
              options={props.groups}
            />
          </Col>
          <Col xs={12} style={{ display: 'none' }}>
            <Field
              name="currentIdESCourse"
              label={props.intl.formatMessage(messages.course)}
              disabled
            />
          </Col>
        </Row>
      </Fragment>
    </Modal>
  );
};

EditStudentModalForm.propTypes = {};

EditStudentModalForm.defaultProps = {
  type: EditStudentModalType.ADD,
};

export default injectIntl(EditStudentModalForm);
